export const PRODUCT_TOURS_STYLES = {
  stepEmphasis: {
    fontWeight: 'bold',
    color: '#FDA670',
  },
};
export const USER_SETTINGS_KEYS = {
  nexla_web_app: 'nexla_web_app',
};

export const PRODUCT_TOURS_KEYS = {
  tour_seen_nx_designer_upgrade: 'tour_seen_nx_designer_upgrade',
  quick_start_guide_completed: 'quick_start_guide_completed',
  quick_start_guide_progress: 'quick_start_guide_progress',
};

export const QUICK_START_GUIDE_KEYS = {
  demo_videos: 'demo_videos',
  nexla_docs: 'nexla_docs',
  set_notifications: 'set_notifications',
  create_flow: 'create_flow',
};
